var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"item-text":"name","prepend-icon":"credit_card","items":_vm.permissions,"return-object":true,"value":_vm.selectedItem,"label":_vm.$t('transportationPermission.select')},on:{"input":_vm.selectPermission}})
}
var staticRenderFns = []

export { render, staticRenderFns }